import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=4c282a29&scoped=true&"
import script from "./MenuSection.vue?vue&type=script&lang=js&"
export * from "./MenuSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c282a29",
  null
  
)

export default component.exports